import * as React from "react";
import RequiredDocDropDown, { SelectOption } from "../components/RequiredDocDropDown";
import { ReqDocAnswerableQuestionMulti } from "../components/ScheduledVisitDocScreen";
import { STRINGS } from "../strings";
import { translate } from "../translate";

const RequiredDocDropdownActivity = (props: ReqDocAnswerableQuestionMulti) => {
  const [isSelectBottomSheetOpen, setIsSelectBottomSheetOpen] = React.useState<boolean>(false);

  const handleOpenSelectBottomSheet = React.useCallback(() => {
    setIsSelectBottomSheetOpen(true);
  }, []);

  const handleCloseSelectBottomSheet = React.useCallback(() => {
    setIsSelectBottomSheetOpen(false);
  }, []);

  const handleChooseOption = React.useCallback(
    (option: SelectOption) => {
      props.handleOnInsertAnswer.call(null, props.questionId, option.value);
      setIsSelectBottomSheetOpen(false);
    },
    [props.handleOnInsertAnswer, props.questionId]
  );

  const options = React.useMemo(() => {
    return props.possibleAnswers.map((ans, index) => {
      return {
        key: "option-" + index,
        value: ans,
      };
    });
  }, [props.possibleAnswers]);

  const currentAnswer = React.useMemo((): SelectOption | null => {
    if (
      props.currentAnswer === undefined ||
      props.currentAnswer === null ||
      typeof props.currentAnswer !== "string"
    ) {
      return null;
    }

    const findAnswer = options.find((opt) => opt.value === props.currentAnswer);
    if (findAnswer === undefined) {
      return null;
    }

    return { key: findAnswer.key, value: props.currentAnswer };
  }, [props.currentAnswer, options]);

  const placeholder = React.useMemo(() => {
    if (currentAnswer === null) {
      return translate(STRINGS.SELECT);
    }
    return currentAnswer.value;
  }, [currentAnswer]);

  return (
    <RequiredDocDropDown
      {...props}
      isSelectBottomSheetOpen={isSelectBottomSheetOpen}
      options={options}
      selectedOption={currentAnswer}
      placeholder={placeholder}
      onChooseOption={handleChooseOption}
      onOpenSelectBottomSheet={handleOpenSelectBottomSheet}
      onCloseSelectBottomSheet={handleCloseSelectBottomSheet}
    />
  );
};

export default RequiredDocDropdownActivity;
